import React from 'react';
import { PieChart,Tooltip,Legend, Pie, Sector,PieLabel, Cell, ResponsiveContainer } from 'recharts';

{/* <td>{easy.total_question + medium.total_question + tough.total_question}</td>
<td>{easy.attempt_question + medium.attempt_question + tough.attempt_question}</td>
<td>{easy.correct_question + medium.correct_question + tough.correct_question}</td>
<td>{easy.incorrect_question + medium.incorrect_question + tough.incorrect_question}</td>
<td>{(easy.total_question + medium.total_question + tough.total_question) - 
(easy.attempt_question + medium.attempt_question + tough.attempt_question)}</td> */}


const DiffcultyLevelChart = (props) => {
    const studentResult = props.studentResult !== undefined && props.studentResult;
    const difficultyLevel = studentResult.difficulty !== undefined && studentResult.difficulty
    const easy = difficultyLevel[0] !== undefined && difficultyLevel[0]
    const medium = difficultyLevel[1] !== undefined && difficultyLevel[1]
    const tough   = difficultyLevel[2] !== undefined && difficultyLevel[2]

    let totl_difficult_quest = parseInt(tough.total_question) / (parseInt(easy.total_question) + parseInt(medium.total_question) + parseInt(tough.total_question)) * 100;
    let totl_medium_quest = parseInt(medium.total_question) / (parseInt(easy.total_question) + parseInt(medium.total_question) + parseInt(tough.total_question)) * 100;
    let totl_easy_quest = parseInt(easy.total_question) / (parseInt(easy.total_question) + parseInt(medium.total_question) + parseInt(tough.total_question)) * 100;
   
    const data = [
        { name: 'Difficult', value: totl_difficult_quest },
        { name: 'Moderate', value: totl_medium_quest },
        { name: 'Easy', value: totl_easy_quest },
      ];
    
      const COLORS = ['#ef4444', '#EAB308', '#0097ff'];
    
    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);
    
      return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
          {`${(percent * 100).toFixed(0)}%`}
        </text>
      );
    };


    return(
        <>
           <div className='difficulty_chartContain'>
           <div style={{ width: "100%", height: "270px" }}>
           <ResponsiveContainer className="pie_chart_wrapper_static">
            <PieChart width={200} height={220}>
            <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={110}
                innerRadius={40}
                fill="#8884d8"
                dataKey="value"
            >
                {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
            </Pie>
            <Legend  />
            <Tooltip />
            </PieChart>
        </ResponsiveContainer>
        </div>
           </div>
        </>
    );
}

export default DiffcultyLevelChart;